export default {
  send (type, message) {
    console.log('Posting ' + type + ': ' + JSON.stringify(message))
    window.parent.postMessage({
      system: 'tavleboka',
      type: type,
      data: message
    }, '*')
  },
  receive (message) {
    return message.data
  }
}



// WEBPACK FOOTER //
// ./src/utils/postMessage.js